export const lukkeyBaseTranslation = {
  "home.hero.reserveCtaLabel": "Get Early Access — $1",
  "home.hero.reserveCtaNote": "Fully refundable. No purchase commitment.",
  "lukkey.hero.title": "LUKKEY",
  "lukkey.hero.subtitle": "Your assets your control",
  "lukkey.hero.reserveSubtitle":
    "Reserve with $1 for Early Bird pricing, priority access, and a free NFC backup card.",
  "lukkey.hero.priceHighlightPrefix": "Kickstarter price",
  "lukkey.hero.priceHighlightMiddle": "Pay $1 now to lock in",
  "lukkey.hero.priceHighlightSuffix": "at launch.",
  "lukkey.hero.priceHighlightSavings": "Save $20.",
  "lukkey.hero.heroCtaLabel": "Reserve for $1",
  "lukkey.hero.heroCtaNote": "Fully refundable. No purchase commitment.",
  "lukkey.hero.buy": "Reserve Lukkey with $1",
  "lukkey.hero.buyWithPrice": "Reserve Lukkey with {{price}}",
  "lukkey.hero.swissBadgeLabel": "Swiss brand",
  "lukkey.hero.seoEyebrow": "Swiss hardware wallet for secure self-custody",
  "lukkey.hero.awards.ifDesignAlt": "iF Design Award 2025 badge",
  "lukkey.hero.awards.redDotAlt": "Red Dot Award 2025 badge",
  "lukkey.cart.title": "Review your cart",
  "lukkey.cart.close": "Close cart",
  "lukkey.cart.empty": "Your cart is empty.",
  "lukkey.cart.delete": "Delete",
  "lukkey.cart.reserveDetailsTitle": "Your $1 reservation includes",
  "lukkey.cart.priceCalloutEyebrow": "Launch pricing",
  "lukkey.cart.priceCalloutBody":
    "Kickstarter price $299. Reserve now for $1 and lock in the $279 launch price.",
  "lukkey.cart.reserveDetails.bullet1": "$20 off Early Bird pricing",
  "lukkey.cart.reserveDetails.bullet2": "Launch-day email updates and first access to the campaign page",
  "lukkey.cart.reserveDetails.bullet3": "Priority shipping",
  "lukkey.cart.reserveDetails.bullet4": "VIP community access",
  "lukkey.cart.reserveDetails.bullet5": "A limited-edition NFC backup card and an exclusive IP gift",
  "lukkey.cart.moreColors": "More colors (Coming soon)",
  "lukkey.cart.comingSoon": "Coming soon",
  "lukkey.cart.total": "Total",
  "lukkey.cart.checkout": "Checkout",
  "lukkey.hero.imageAlt": "Lukkey cold wallet hero product",
  "lukkey.seo.title":
    "LUKKEY Hardware Wallet | Offline Crypto Cold Wallet with Fingerprint Access",
  "lukkey.seo.description":
    "LUKKEY is a Swiss hardware wallet built for secure self-custody, with offline private key protection, an EAL6+ secure element, fingerprint access, NFC backup, and support for multiple independent wallets.",
  "lukkey.seoIntent.eyebrow": "Hardware wallet guide",
  "lukkey.seoIntent.title":
    "Why people search for a cold wallet like LUKKEY",
  "lukkey.seoIntent.intro":
    "A hardware wallet should do more than look secure. It should keep private keys offline, make recovery practical, and give long-term crypto holders a clearer self-custody workflow.",
  "lukkey.seoIntent.cards.offline.title": "Offline private key storage",
  "lukkey.seoIntent.cards.offline.body":
    "LUKKEY is designed as a hardware wallet that keeps private keys offline instead of leaving them exposed in a browser, exchange, or always-connected app environment.",
  "lukkey.seoIntent.cards.compare.title": "Cold wallet vs hot wallet",
  "lukkey.seoIntent.cards.compare.body":
    "For long-term holders and serious crypto users, a cold wallet reduces remote attack surface and gives more direct control than storing assets on exchanges or software wallets alone.",
  "lukkey.seoIntent.cards.recovery.title":
    "Fingerprint access and NFC backup",
  "lukkey.seoIntent.cards.recovery.body":
    "LUKKEY combines hardware-first security with practical recovery tools, including fingerprint access for daily use and NFC backup flows built for safer self-custody.",
  "lukkey.seoIntent.cards.fit.title": "Built for secure self-custody",
  "lukkey.seoIntent.cards.fit.body":
    "If you are looking for a hardware wallet for Bitcoin, Ethereum, USDT, and multi-account crypto management, LUKKEY is built around privacy, separation, and long-term control.",
  "lukkey.highlights.eyebrow": "Product highlights",
  "lukkey.highlights.title": "Get the Lukkey highlights.",
  "lukkey.highlights.description":
    "Five reasons serious self-custody users start here. Each highlight maps directly to a deeper section below.",
  "lukkey.highlights.cards.chip.title": "EAL6+ Secure Chip",
  "lukkey.highlights.cards.chip.description":
    "Hardware-rooted protection keeps critical key material inside a certified secure element.",
  "lukkey.highlights.cards.chip.sectionLabel": "Chip security",
  "lukkey.highlights.cards.multiAccount.title":
    "3 Independent Recovery Phrases",
  "lukkey.highlights.cards.multiAccount.description":
    "Split long-term holdings, active funds, and separate identities into distinct wallets on one device.",
  "lukkey.highlights.cards.multiAccount.sectionLabel": "Multi-account",
  "lukkey.highlights.cards.safeMode.title": "Safe Mode",
  "lukkey.highlights.cards.safeMode.description":
    "A disguised interface and hidden-account flow reduce exposure in travel, public-use, and coercion scenarios.",
  "lukkey.highlights.cards.safeMode.sectionLabel": "Safety layer",
  "lukkey.highlights.cards.backup.title": "NFC Backup Card",
  "lukkey.highlights.cards.backup.description":
    "Tap to back up or restore recovery phrases with a dedicated card built for offline continuity.",
  "lukkey.highlights.cards.backup.sectionLabel": "Backup",
  "lukkey.highlights.cards.trust.title": "Open & Verifiable Security",
  "lukkey.highlights.cards.trust.description":
    "Independent review matters in cold storage. Open architecture makes trust auditable instead of assumed.",
  "lukkey.highlights.cards.trust.sectionLabel": "Trust",
  "lukkey.highlights.carousel.previous": "Previous highlights",
  "lukkey.highlights.carousel.next": "Next highlights",
  "lukkey.physical.title": "Security, built in silicon.",
  "lukkey.physical.subtitle":
    "A hardware security architecture built on multiple secure elements, anchored by an EAL6+ root of trust and reinforced by tamper-resistant circuit and structural design.",
  "lukkey.physical.annotation.title": "Hardware root of trust.",
  "lukkey.physical.annotation.description":
    "Multiple secure elements, anchored by EAL6+ and reinforced by tamper-resistant circuit and structural design.",
  "lukkey.physical.cardTamper.title":
    "PCI-grade anti-tamper (potting + self-destruct)",
  "lukkey.physical.cardTamper.description":
    "Exploded-structure visualization with semi-transparent potting around the core chip, clearly layered but inaccessible.",
  "lukkey.physical.cardChip.title": "EAL6+ secure chip",
  "lukkey.physical.cardChip.description":
    "The chip floats in dark space while data beams are constrained by secure boundaries.",
  "lukkey.physical.explode.coreChip": "Core Chip",
  "lukkey.physical.explode.securityBoundary": "Security Boundary",
  "lukkey.physical.explode.pottingLayer": "Potting Layer",
  "lukkey.physical.explode.outerShell": "Outer Shell",
  "lukkey.design.title": "Design is not decoration, it is credibility",
  "lukkey.design.description":
    "Industrial design with iF and Red Dot-level craftsmanship, emphasizing chamfered edges and subtle glass reflections.",
  "lukkey.design.featureTitle": "Color touchscreen · card-sized form",
  "lukkey.design.featureDescription":
    "Compared 1:1 with a real bank card, highlighting the pocketable 9.6mm thickness.",
  "lukkey.design.thickness": "Thickness 9.6mm",
  "lukkey.design.closing":
    "Macro transitions and moving highlights still resolve into a refined full form.",
  "lukkey.design.controls.closePanel": "Close feature panel",
  "lukkey.design.feature.colors": "Colors",
  "lukkey.design.feature.sizes": "Sizes",
  "lukkey.design.feature.display": "Display",
  "lukkey.design.feature.connectivity": "Connectivity",
  "lukkey.design.feature.durability": "Durability",
  "lukkey.design.color.champagne": "Champagne Gold",
  "lukkey.design.color.black": "Black",
  "lukkey.design.color.silver": "Silver",
  "lukkey.design.panel.colors.title": "Colors.",
  "lukkey.design.panel.colors.body": "Choose from three bold finishes.",
  "lukkey.design.panel.colors.selected": "LUKKEY shown in {{color}}.",
  "lukkey.design.panel.sizes.body":
    "Dimensions: 93.2 mm (L) x 56.7 mm (W) x 9.6 mm (H). Weight: 85 g. Credit-card footprint with a compact thickness for everyday carry.",
  "lukkey.design.panel.display.body":
    "Display: 4.3-inch touchscreen with 480 x 800 resolution for clear verification and signing details.",
  "lukkey.design.panel.connectivity.body":
    "Connectivity: Bluetooth for secure wireless connection and transaction flow.",
  "lukkey.design.panel.durability.body": "Up to 3 hours of continuous use.",
  "lukkey.reliability.title": "IP68 Waterproof\nIP6X Dustproof",
  "lukkey.reliability.description":
    "IP68-rated waterproofing and IP6X dustproof protection, built to block water and fine-particle intrusion in harsh environments.",
  "lukkey.reliability.canvasLine1": "IP68 Waterproof",
  "lukkey.reliability.canvasLine2": "IP6X Dustproof",
  "lukkey.reliability.bullet1": "Slow-motion water enveloping the device",
  "lukkey.reliability.bullet2": "High-speed droplets with zero ingress",
  "lukkey.reliability.bullet3": "Dust-proof, waterproof, and drop-resistant",
  "lukkey.reliability.imageAlt": "Lukkey IP68 waterproof showcase",
  "lukkey.system.title": "Safe Mode",
  "lukkey.system.description":
    "A discreet protection layer for sensitive situations.\n\nSafenotes disguises the wallet interface as a notes-style page,\nwhile only the active account remains visible.\nSensitive operations such as single-account deletion are restricted.",
  "lukkey.system.account.accountA": "Account A",
  "lukkey.system.account.hiddenWallet": "Hidden Wallet",
  "lukkey.system.account.decoyVault": "Decoy Vault",
  "lukkey.system.account.locked": "Locked",
  "lukkey.system.multiAccountTitle":
    "Support for 3 Independent Recovery Phrases",
  "lukkey.system.multiAccountDescription":
    "Create up to three completely independent wallets, each secured by its own recovery phrase. Separate assets, strategies, or identities while keeping full control of your digital assets.",
  "lukkey.system.layers.primary": "Primary",
  "lukkey.system.layers.vault": "Vault",
  "lukkey.system.layers.shadow": "Shadow",
  "lukkey.system.modalImageAlt": "LUKKEY wallet product image",
  "lukkey.system.openDetailsAria": "Open details for {{title}}",
  "lukkey.system.safeModeAccess.titleStrong": "Safe Mode\nAccess",
  "lukkey.system.safeModeAccess.titleSoft":
    "Special password opens a disguised page and hides other accounts.",
  "lukkey.system.safeModeAccess.modalTitle": "Safe Mode Access",
  "lukkey.system.safeModeAccess.modalDescription":
    "A dedicated Safe Mode password opens a disguised notes-style interface, so only the intended account appears while the rest of the wallet stays concealed.",
  "lukkey.system.safeModeAccess.bullet1":
    "Unlocks a decoy interface instead of the full wallet home",
  "lukkey.system.safeModeAccess.bullet2":
    "Keeps non-active accounts out of view during sensitive moments",
  "lukkey.system.safeModeAccess.bullet3":
    "Lets you pass casual inspection without exposing hidden balances",
  "lukkey.system.safeModeAccess.imageAlt": "Safe Mode access illustration",
  "lukkey.system.hiddenAccounts.titleStrong": "Hidden\nAccounts",
  "lukkey.system.hiddenAccounts.titleSoft":
    "Decoy access keeps sensitive wallets concealed until the correct password is entered.",
  "lukkey.system.hiddenAccounts.modalTitle": "Hidden Accounts",
  "lukkey.system.hiddenAccounts.modalDescription":
    "Sensitive wallets remain invisible behind decoy access. Only the correct password reveals the real account set, reducing the chance of unwanted discovery.",
  "lukkey.system.hiddenAccounts.bullet1":
    "Separates visible decoy accounts from concealed high-value wallets",
  "lukkey.system.hiddenAccounts.bullet2":
    "Prevents hidden wallets from appearing in routine unlock flows",
  "lukkey.system.hiddenAccounts.bullet3":
    "Adds a practical privacy layer for travel, public use, and coercion scenarios",
  "lukkey.daily.title": "Fingerprint Unlock",
  "lukkey.daily.description":
    "Unlock your wallet instantly with fingerprint authentication.\n\nFast, seamless, and verified directly on the device.",
  "lukkey.capability.title": "NFT Support",
  "lukkey.capability.description":
    "A dark-space asset display bay with glassy cards and low saturation to emphasize ownership and control.",
  "lukkey.capability.nftItem": "NFT #{{index}}",
  "lukkey.backup.title": "NFC Backup Card",
  "lukkey.backup.description":
    "An NFC backup card with an EAL6+ secure element.\nSimply tap the device to securely back up or import recovery phrases.",
  "lukkey.backup.imageAlt": "NFC mnemonic backup demonstration",
  "lukkey.trust.title": "Open & Verifiable Security",
  "lukkey.trust.description":
    "Built on an EAL6+ secure element and an open-source architecture,\nLUKKEY allows both hardware and software security to be independently verified.\n\nKey generation, storage, and signing remain protected inside the device,\nwhile open-source code enables transparent security review by the community.\n\nSecurity you can verify. Control that remains yours.",
  "lukkey.trust.imageAlt": "Open source verification preview",
  "lukkey.video.title": "Built to Protect. Designed to Endure.",
  "lukkey.video.description":
    "Swiss-crafted and security-obsessed, LUKKEY is the cold wallet for those who demand total control.",
  "lukkey.values.privacy.title": "Privacy",
  "lukkey.values.privacy.description":
    "Your keys never leave the device. Air-gapped signing keeps sensitive operations fully offline.",
  "lukkey.values.inclusive.title": "Inclusive Design",
  "lukkey.values.inclusive.description":
    "Human-centered design, built to be clear for beginners and efficient for experts.",
  "lukkey.values.secure.title": "Secure",
  "lukkey.values.secure.description":
    "Hardware-backed protection with multi-layer safeguards against tampering, extraction, and spoofing.",
  "lukkey.values.environment.title": "Environment",
  "lukkey.values.environment.description":
    "Built for long-term use with durable materials, repair-minded structure, and reduced replacement waste.",
  "lukkey.contact.title": "Stay in touch",
  "lukkey.contact.announcements": "Announcements can be found in our blog.",
  "lukkey.contact.pressLabel": "Press contact:",
  "AboutUs.quote":
    "LUKKEY builds the secure layer between people and digital assets.",
  "AboutUs.block1":
    "LUKKEY is based in Switzerland. It focuses on hardware wallets designed for secure self-custody.",
  "AboutUs.block2":
    "Its products combine secure elements, anti-tamper protection, and fully offline architecture. The goal is to keep private keys in an isolated environment.",
  "AboutUs.block3":
    "The system is designed without Wi-Fi, USB, or direct network dependence. Fingerprint access, NFC backup tools, and broad asset support keep the product practical in daily use.",
  "AboutUs.block5":
    "LUKKEY follows an open and auditable approach for core firmware and software. Security claims should remain inspectable and verifiable.",
  "lukkey.modal.contentLabel": "Email confirmation",
  "lukkey.modal.title": "Confirm your email",
  "lukkey.modal.description1":
    "Please open the confirmation email sent to you and click the verification link. Please be sure to check your spam folder too.",
  "lukkey.modal.description2":
    "You will be able to unsubscribe at any time.",
  "lukkey.modal.close": "Close",
  "lukkey.modal.closeDialog": "Close dialog",
  "lukkey.faq.faq1.question":
    "What makes LUKKEY different from other hardware wallets?",
  "lukkey.faq.faq1.paragraph1":
    "LUKKEY is designed to combine strong security with everyday usability.",
  "lukkey.faq.faq1.paragraph2":
    "LUKKEY aims to make self-custody safer and easier for everyone.",
  "lukkey.faq.faq1.bullet1":
    "EAL6+ secure element chip for advanced key protection",
  "lukkey.faq.faq1.bullet2":
    "Fingerprint authentication for fast and secure access",
  "lukkey.faq.faq1.bullet3":
    "Three independent wallets on one device for asset separation and privacy",
  "lukkey.faq.faq1.bullet4":
    "Cold signing architecture to keep private keys fully offline",
  "lukkey.faq.faq2.question": "Is LUKKEY open source?",
  "lukkey.faq.faq2.paragraph1":
    "Yes. LUKKEY is open source, allowing the community to review the code and carry out independent security audits.",
  "lukkey.faq.faq2.paragraph2":
    "We believe a hardware wallet should be transparent and verifiable, and open source is a core part of building that trust.",
  "lukkey.faq.faq3.question": "What does the EAL6+ secure element do?",
  "lukkey.faq.faq3.paragraph1":
    "The EAL6+ secure element is a specialized chip designed to protect sensitive cryptographic data.",
  "lukkey.faq.faq3.paragraph2":
    "It securely stores your private keys and performs cryptographic operations inside a tamper-resistant environment, protecting your assets from physical and digital attacks.",
  "lukkey.faq.faq3.paragraph3":
    "This level of security certification is commonly used in bank cards, passports, and high-security devices.",
  "lukkey.faq.faq4.question":
    "Can I create three independent wallets on one device?",
  "lukkey.faq.faq4.paragraph1": "Yes.",
  "lukkey.faq.faq4.paragraph2":
    "LUKKEY allows you to create three completely independent wallets on a single device, each with its own private keys and recovery phrase.",
  "lukkey.faq.faq4.paragraph3":
    "Each wallet operates independently and securely.",
  "lukkey.faq.faq4.bullet1": "Separate long-term holdings and daily funds",
  "lukkey.faq.faq4.bullet2": "Manage different portfolios",
  "lukkey.faq.faq4.bullet3":
    "Create hidden or decoy wallets for additional privacy",
  "lukkey.faq.faq5.question": "What happens if I lose the device?",
  "lukkey.faq.faq5.paragraph1":
    "Your crypto assets are not stored on the device, but on the blockchain.",
  "lukkey.faq.faq5.paragraph2":
    "When setting up LUKKEY, you will generate a recovery phrase used to restore your wallet.",
  "lukkey.faq.faq5.paragraph3":
    "LUKKEY also supports an NFC backup card, providing a convenient way to securely store your recovery information.",
  "lukkey.faq.faq5.paragraph4":
    "If your device is lost or damaged, you can restore your wallet using your recovery phrase or NFC backup card.",
  "lukkey.faq.faq5.paragraph5":
    "As long as your backup is safe, your funds remain safe.",
  "lukkey.faq.faq6.question": "What does the $1 reservation include?",
  "lukkey.faq.faq6.paragraph1":
    "The $1 reservation secures your place for the upcoming Kickstarter launch.",
  "lukkey.faq.faq6.paragraph2":
    "This ensures you can claim the best available offer when the campaign goes live.",
  "lukkey.faq.faq6.bullet1": "Early access to the Kickstarter campaign",
  "lukkey.faq.faq6.bullet2": "Exclusive early-bird pricing",
  "lukkey.faq.faq6.bullet3":
    "Priority notification before the public launch",
  "lukkey.faq.faq7.question": "When will LUKKEY launch on Kickstarter?",
  "lukkey.faq.faq7.paragraph1":
    "LUKKEY is planned to launch on Kickstarter in 2026.",
  "lukkey.faq.faq7.paragraph2":
    "All reservation holders will receive early access and notification before the public launch.",
  "lukkey.faq.faq8.question": "Which assets will LUKKEY support?",
  "lukkey.faq.faq8.paragraph1":
    "LUKKEY supports 30+ blockchain networks and thousands of cryptocurrencies and NFT assets.",
  "lukkey.faq.faq8.paragraph2":
    "Users can securely manage both cryptocurrencies and NFTs on one device.",
  "lukkey.faq.faq8.paragraph3":
    "More networks and assets will continue to be added through firmware and app updates.",
  "lukkey.faq.faq8.bullet1": "Bitcoin (BTC)",
  "lukkey.faq.faq8.bullet2": "Ethereum (ETH)",
  "lukkey.faq.faq8.bullet3": "USDT",
  "lukkey.faq.faq8.bullet4": "BNB Chain",
  "lukkey.faq.faq8.bullet5": "TRON",
  "lukkey.faq.faq8.bullet6": "Polygon",
  "lukkey.faq.faq8.bullet7": "and many more",
};
